import { Col, FormGroup, FormLabel, Row } from "react-bootstrap";
import InputText from "../../../components/Forms/Element/InputText";
import StatusCheckBox from "../../../components/Common/StatusCheckbox";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { convertStatusToBoolean } from "../../../../utils/ConverterUtils";
import AsteriskRequired from "../../../components/Common/AsteriskRequired";
import FormSection from "../../../components/Common/Form/FormSection";

const Form = (props) => {
    const { t } = useTranslation();
    const { status, setStatus, commissionable, setCommissionable, formik, entityData } = props;

    useEffect(() => {
        // Preenche os valores nos campos.
        if (entityData != null) {
            formik.setFieldValue('name', entityData.name);
            setStatus(convertStatusToBoolean(entityData.status));
            // Categoria cadastrada antes deste campo existir vem sem ele e comissiona, que
            // é como ela sempre se comportou.
            setCommissionable(entityData.commissionable !== false);
        }

        // eslint-disable-next-line
    }, [entityData]);

    return (
        <>
            <div className="form-layout form-layout--spaced">
                <FormSection
                    title={t('basic_information')}
                    description={t('category_basic_information_hint')}
                    icon="fa-solid fa-tag"
                >
                    <Row className="g-3">
                        <Col md={6}>
                            <FormGroup>
                                <FormLabel>{t('name')} <AsteriskRequired /></FormLabel>
                                <InputText
                                    name="name"
                                    placeholder={t('category_name_placeholder')}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.name}
                                    error={formik.errors.name}
                                    maxlenght="50"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>

                <FormSection
                    title={t('commission')}
                    description={t('category_commission_hint')}
                    icon="fa-solid fa-hand-holding-dollar"
                    compact
                >
                    <Row>
                        <Col md={12}>
                            <FormGroup className="mb-0">
                                {/* Marca positiva ("gera comissão") em vez de "não comissiona":
                                    o padrão é comissionar, e caixa desmarcada por padrão faria
                                    o operador achar que precisa marcar tudo. */}
                                <StatusCheckBox
                                    name="commissionable"
                                    label={t('category_commissionable')}
                                    defaultChecked={commissionable}
                                    checked={commissionable}
                                    onClick={() => setCommissionable(!commissionable)} />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>

                <FormSection
                    title={t('status')}
                    description={t('category_status_hint')}
                    icon="fa-solid fa-toggle-on"
                    compact
                >
                    <Row>
                        <Col md={12}>
                            <FormGroup className="mb-0">
                                <StatusCheckBox
                                    name="status"
                                    defaultChecked={status}
                                    checked={status}
                                    onClick={() => setStatus(!status)} />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>
            </div>
        </>
    );
}

export default Form;
